// @ts-nocheck
import React from "react";

// This is a simplified Figma-inspired component for comparing assets page.
// It includes dropdowns for selecting assets, date pickers, and an area chart.

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const yAxis = ["100", "80", "60", "40", "20", "0"];

// AreaChart component to display the area chart visualization
const AreaChart = () => {
  return (
    <div className="relative">
      <div className="absolute left-0 top-0 flex h-full w-10 flex-col justify-between text-xs text-slate-400">
        {yAxis.map((label) => (
          <span key={label} className="text-right">
            {label}
          </span>
        ))}
      </div>
      <div className="ml-12">
        <div className="h-[200px] w-full rounded-lg bg-white">
          <svg viewBox="0 0 600 200" className="h-full w-full">
            <defs>
              <linearGradient id="blueFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#dff3fb" stopOpacity="0.9" />
                <stop offset="100%" stopColor="#dff3fb" stopOpacity="0.3" />
              </linearGradient>
              <linearGradient id="greenFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#e6f7d9" stopOpacity="0.9" />
                <stop offset="100%" stopColor="#e6f7d9" stopOpacity="0.4" />
              </linearGradient>
            </defs>
            {Array.from({ length: 12 }).map((_, i) => (
              <line
                key={`grid-${i}`}
                x1={50 * i}
                y1="0"
                x2={50 * i}
                y2="200"
                stroke="#f1f5f9"
                strokeWidth="1"
              />
            ))}
            {Array.from({ length: 6 }).map((_, i) => (
              <line
                key={`row-${i}`}
                x1="0"
                y1={i * 40}
                x2="600"
                y2={i * 40}
                stroke="#f8fafc"
                strokeWidth="1"
              />
            ))}
            <path
              d="M0 70 L30 72 L60 66 L90 68 L120 62 L150 54 L180 60 L210 52 L240 58 L270 50 L300 55 L330 57 L360 53 L390 50 L420 58 L450 52 L480 60 L510 58 L540 62 L570 66 L600 64 L600 200 L0 200 Z"
              fill="url(#blueFill)"
            />
            <path
              d="M0 95 L30 96 L60 100 L90 120 L120 112 L150 108 L180 106 L210 102 L240 88 L270 92 L300 98 L330 86 L360 88 L390 92 L420 104 L450 110 L480 90 L510 82 L540 78 L570 76 L600 74 L600 200 L0 200 Z"
              fill="url(#greenFill)"
            />
            <path
              d="M0 70 L30 72 L60 66 L90 68 L120 62 L150 54 L180 60 L210 52 L240 58 L270 50 L300 55 L330 57 L360 53 L390 50 L420 58 L450 52 L480 60 L510 58 L540 62 L570 66 L600 64"
              fill="none"
              stroke="#7aa3b7"
              strokeWidth="2"
            />
            <path
              d="M0 95 L30 96 L60 100 L90 120 L120 112 L150 108 L180 106 L210 102 L240 88 L270 92 L300 98 L330 86 L360 88 L390 92 L420 104 L450 110 L480 90 L510 82 L540 78 L570 76 L600 74"
              fill="none"
              stroke="#8aa33d"
              strokeWidth="2"
            />
          </svg>
        </div>
        <div className="mt-3 flex justify-between text-xs text-slate-400">
          {months.map((month) => (
            <span key={month} className="w-full text-center">
              {month}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

// Main CompareAsset component
const CompareAsset = () => {
  return (
    <div className="flex-1 bg-slate-100/70 px-6 py-8">
      <div className="mx-auto max-w-[860px]">
        <div className="rounded-2xl border border-slate-200 bg-white shadow-xl">
          <div className="flex items-start justify-between px-6 pb-4 pt-5">
            <div>
              <h1 className="text-xl font-semibold text-slate-900">Compare Assets</h1>
              <p className="text-sm text-slate-500">Select from an existing Asset</p>
            </div>
            <button className="rounded-full p-1 text-slate-400 hover:text-slate-600">
              <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M6 6l12 12M18 6l-12 12" />
              </svg>
            </button>
          </div>

          <div className="border-t border-slate-100 px-6 pb-6 pt-4">
            <div className="grid gap-4 md:grid-cols-2">
              <div>
                <label className="text-sm font-medium text-slate-600">Asset Name</label>
                <button className="mt-2 flex w-full items-center justify-between rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-800">
                  Turbine flow
                  <svg viewBox="0 0 20 20" className="h-4 w-4 text-slate-500" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 7l5 5 5-5" />
                  </svg>
                </button>
              </div>
              <div>
                <label className="text-sm font-medium text-slate-600">Date Issued</label>
                <button className="mt-2 flex w-full items-center gap-3 rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-800">
                  <svg viewBox="0 0 24 24" className="h-4 w-4 text-slate-500" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="5" width="18" height="16" rx="2" />
                    <path d="M16 3v4M8 3v4M3 11h18" />
                  </svg>
                  Jan 6, 2022 - Jan 13, 2022
                </button>
              </div>
            </div>

            <div className="mt-6">
              <AreaChart />
            </div>

            <div className="mt-8 grid gap-4 md:grid-cols-2">
              <div>
                <label className="text-sm font-medium text-slate-600">Model Name</label>
                <button className="mt-2 flex w-full items-center justify-between rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-800">
                  Asset flow
                  <svg viewBox="0 0 20 20" className="h-4 w-4 text-slate-500" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 7l5 5 5-5" />
                  </svg>
                </button>
              </div>
              <div>
                <label className="text-sm font-medium text-slate-600">Date Issued</label>
                <button className="mt-2 flex w-full items-center gap-3 rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-800">
                  <svg viewBox="0 0 24 24" className="h-4 w-4 text-slate-500" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="5" width="18" height="16" rx="2" />
                    <path d="M16 3v4M8 3v4M3 11h18" />
                  </svg>
                  Jan 6, 2022 - Jan 13, 2022
                </button>
              </div>
            </div>

            <div className="mt-6">
              <AreaChart />
            </div>
          </div>

          <div className="flex justify-end border-t border-slate-100 px-6 py-4">
            <button className="flex items-center gap-2 rounded-lg bg-slate-600 px-5 py-2 text-sm font-semibold text-white shadow">
              <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2l3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1 3-6z" />
              </svg>
              Pin to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompareAsset;
